import { useState, useEffect } from 'react';

export const useScreenColumns = () => {
    const [columns, setColumns] = useState(getColumns(window.innerWidth));

    function getColumns(width) {
        if (width >= 1200) return 6;     // large screens
        if (width >= 768) return 4;      // medium screens
        return 2;                        // small screens
    }

    useEffect(() => {
        const handleResize = () => {
            setColumns(getColumns(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return columns;
};